import React, { useState, useEffect } from 'react'; // Component
import classNames from 'classnames';
import moment from 'moment';
import IconError from 'assets/icons/icon-error.svg';
import { format, parse } from 'date-fns';
import { isEmpty } from 'lodash';

function DateInput({
  isValid,
  value,
  label,
  name,
  onInputChange,
  minor,
  minorWarning,
  isSubmitClicked,
  disabled,
  errorMessage,
}) {
  const [isInputTouched, setIsInputTouched] = useState(false);
  const [dateValue, setDateValue] = useState(new Date());

  const maxDate = new Date().toISOString().split('T')[0];

  useEffect(() => {
    // FORMAT VALUE SO FRONT DATE CAN BE DISPLAYED
    if (!isEmpty(value)) {
      const formattedValue = format(
        parse(value, 'dd/MM/yyyy', new Date()),
        'yyyy-MM-dd',
      );
      setDateValue(formattedValue);
    }
  }, [value]);

  const validateNumberAndForwardSlash = (event) => {
    const keyCode = event.keyCode || event.which;
    if (keyCode < 47 || keyCode > 57) {
      event.preventDefault();
    }
  };

  const onChange = ({ target }) => {
    const input = format(Date.parse(target.value), 'ddMMyyyy');
    onInputChange(target.name, input);
    setDateValue(target.value);
  };

  const onInputBlur = () => {
    setIsInputTouched(true);

    if (minor && isValid) {
      const years = Math.floor(
        moment(new Date()).diff(
          moment(new Date(dateValue), 'DD/MM/YYYY'),
          'years',
          true,
        ),
      );
      if (+years < minor) {
        minorWarning();
      }
    }
    // const cleanNumber = value.replace(new RegExp('-', 'g'), ''); // remove the / to store only the number in the store
    // // const formattedValue = value.replace(/(\d{2})(\d{2})(\d{4})/, '$3/$2/$1');
    // console.log('cleanNumber', cleanNumber);
    // // onInputChange(event.target.name, cleanNumber);
    // if (cleanNumber.length < 9 && (/\d/.test(cleanNumber.slice(-1)) || cleanNumber.slice(-1) === '')) {
    //   if (isValid) {
    //     onInputChange(event.target.name, cleanNumber);
    //   }
    //   if (minor && isValid) {
    //     const years = Math.floor(moment(new Date()).diff(moment(value, 'DD/MM/YYYY'), 'years', true));
    //     if (+years < minor) {
    //       minorWarning();
    //     }
    //   }
    // }
  };

  const inputClasses = classNames({
    'form-fieldset__input': true,
    'form-fieldset__input--disabled': disabled,
    'form-fieldset__input--error':
      !isValid && (isInputTouched || isSubmitClicked),
  });

  return (
    <section className="form-fieldset">
      {label && <span className="form-fieldset__label">{label}</span>}
      <div className={inputClasses}>
        <input
          type="date"
          name={name}
          placeholder="DD/MM/YYYY"
          value={dateValue}
          onKeyPress={validateNumberAndForwardSlash}
          onChange={onChange}
          onBlur={onInputBlur}
          min="1900-01-01"
          max={maxDate}
        />
        {!isValid && (isInputTouched || isSubmitClicked) && (
          <img
            className="form-fieldset__input__icon"
            src={IconError}
            alt="error"
          />
        )}
      </div>

      {!isValid && (isInputTouched || isSubmitClicked) && errorMessage && (
        <span className="notification notification--error">
          {errorMessage[0]}
        </span>
      )}
    </section>
  );
}

export default DateInput;
